import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-sponsors',
  templateUrl: './event-sponsors.component.html',
  styleUrls: ['./event-sponsors.component.scss']
})
export class EventSponsorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/event/event-sponsors/event-sponsors.component.ts